import React from 'react'
import DefaultSettingManagement from './abstract/DefaultSettingManagement'
import Window from '../../../../common/Window'
import Loading from '../../../../common/component/Loading'

class UchiwakeSetting extends DefaultSettingManagement {
  constructor (props) {
    super(props)
    this.state = {isLoaded: false}
    this.systemSettingName = 'UchiwakeSetting'
  }
  onInsert (offset) {
    offset = Number(offset)
    const UchiwakeSetting = this.getSettingData()
    UchiwakeSetting.splice(offset + 1, 0,
      {
        'name': null,
        'specification': null,
        'suuryou': null,
        'tani': '㎡',
        'isKatawakuSuuryou': true,
        'daikuBugakari': null,
        'daikuNinku': null,
        'kaitaiBugakari': null,
        'kaitaiNinku': null,
        'primeContractorUnitPrice': null,
        'note': null,
        'materialMokuzaiUnitPrice': null,
        'meterialMokuzaiNote': null,
        'materialShoumouhinUnitPrice': null,
        'meterialShoumouhinNote': null,
        'materialKouseizaiUnitPrice': null,
        'meterialKouseizaiNote': null
      }
    )
    this.setState({
      UchiwakeSetting: UchiwakeSetting
    })
  }
  onDelete (offset) {
    if (this.getSettingData().length > 1) {
      Window.confirm('この行を削除してもよろしいですか?', () => {
        offset = Number(offset)
        const UchiwakeSetting = this.getSettingData()
        UchiwakeSetting.splice(offset, 1)
        this.setState({
          UchiwakeSetting: UchiwakeSetting
        })
        Window.closeDialog()
      })
    }
  }
  onMoveUp (offset) {
    offset = Number(offset)
    if (offset > 0) {
      const UchiwakeSetting = this.getSettingData()
      UchiwakeSetting.splice(offset - 1, 2, UchiwakeSetting[offset], UchiwakeSetting[offset - 1])
      this.setState({
        UchiwakeSetting: UchiwakeSetting
      })
    }
  }
  onMoveDown (offset) {
    offset = Number(offset)
    const UchiwakeSetting = this.getSettingData()
    if (offset < UchiwakeSetting.length - 1) {
      offset++
      UchiwakeSetting.splice(offset - 1, 2, UchiwakeSetting[offset], UchiwakeSetting[offset - 1])
      this.setState({
        UchiwakeSetting: UchiwakeSetting
      })
    }
  }
  getEditor (index, attributeName) {
    const value = this.state.UchiwakeSetting[index][attributeName] ? this.state.UchiwakeSetting[index][attributeName] : ''
    return (
      <input type='text' name={attributeName} value={value} onChange={(e) => this.changed(index, attributeName, e)} />
    )
  }
  changed (index, attributeName, e) {
    const UchiwakeSetting = this.state.UchiwakeSetting
    UchiwakeSetting[index][attributeName] = e.target.value
    this.setState({
      UchiwakeSetting: UchiwakeSetting
    })
  }
  check (index, attributeName, e) {
    const UchiwakeSetting = this.state.UchiwakeSetting
    UchiwakeSetting[index][attributeName] = !UchiwakeSetting[index][attributeName]
    this.setState({
      UchiwakeSetting: UchiwakeSetting
    })
  }

  render () {
    if (!this.state.isLoaded) {
      return <Loading />
    }
    const UchiwakeSetting = this.state.UchiwakeSetting
    const UchiwakeSettingToShow = UchiwakeSetting.map((toukyuu, index, list) => {
      const isTop = (index === 0)
      const isBottom = (index === list.length - 1)
      const isOnlyOne = (list.length <= 1)
      return (
        <tr key={index}>
          <th className='kw-ds-no'>{index + 1}</th>
          <td>{this.getEditor(index, 'name')}</td>
          <td>{this.getEditor(index, 'specification')}</td>
          <td className='kw-ds-tani'>{this.getEditor(index, 'tani')}</td>
          <td className='kw-ds-katawaku-suuryou'><label className='kw-pointer'><input type='checkbox' checked={UchiwakeSetting[index].isKatawakuSuuryou} onChange={(e) => this.check(index, 'isKatawakuSuuryou', e)} />&nbsp;反映する</label></td>
          <td className='kw-ds-gyou-sousa-icons'>
            <span className='text-success'><i className='icon-plus-sign kw-pointer' onClick={this.onInsert.bind(this, index)} /></span>
            <span className='text-error'><i className='icon-minus-sign' onClick={this.onDelete.bind(this, index)}
              style={isOnlyOne ? {color: 'gray', cursor: 'not-allowed'} : {color: 'rgb(185, 74, 72)', cursor: 'pointer'}} /></span>
            <span className='text-info'><i className='icon-circle-arrow-up' style={isTop ? {color: 'gray', cursor: 'not-allowed'} : {color: 'rgb(58, 135, 173)', cursor: 'pointer'}}
              onClick={this.onMoveUp.bind(this, index)} /></span>
            <span className='text-info'><i className='icon-circle-arrow-down' style={isBottom ? {color: 'gray', cursor: 'not-allowed'} : {color: 'rgb(58, 135, 173)', cursor: 'pointer'}}
              onClick={this.onMoveDown.bind(this, index)} /></span>
          </td>
        </tr>
      )
    })
    const UchiwakeSettingTable = (
      <div>
        <table className='kw-ds-detail-tbl'>
          <thead>
            <tr>
              <th className='kw-ds-no' />
              <th className='kw-ds-name' />
              <th className='kw-ds-specification' />
              <th className='kw-ds-tani' />
              <th className='kw-ds-katawaku-suuryou' />
              <th className='kw-ds-gyou-sousa' />
            </tr>
          </thead>
          <tbody>
            <tr>
              <th className='kw-ds-no'>No.</th>
              <th>名称</th>
              <th>仕様</th>
              <th className='kw-ds-tani'>単位</th>
              <th className='kw-ds-katawaku-suuryou'>型枠数量反映</th>
              <th className='kw-ds-gyou-sousa'>行操作</th>
            </tr>
            {UchiwakeSettingToShow}
          </tbody>
        </table>
      </div>
    )

    return (
      <form id='userSecurityForm' className='form-horizontal' method='post' onSubmit={this.onSubmit.bind(this)}>
        <div className='row'>
          <fieldset className='kw-ds-regist-area span16'>
            <legend>工事内訳項目</legend>
            <div className='alert alert-block alert-info'>
              <p>
                必要な情報を入力して最後に「登録」ボタンを押してください。
              </p>
            </div>
            {UchiwakeSettingTable}
            <footer id='submit-actions' className='form-actions'>
              <button id='submit-button' type='submit' className='btn btn-primary' name='action' value='CONFIRM'>登録</button>
            </footer>
          </fieldset>
        </div>
      </form>
    )
  }
}
export default UchiwakeSetting



// WEBPACK FOOTER //
// ./src/admin/pages/secure/DefaultSetting/UchiwakeSetting.js